import { Component, Input, OnInit, Output } from '@angular/core';

import { CacheService } from '../../../global/ng2-cache/services/cache.service';
import { Subject } from 'rxjs/Subject';
import { Constants, Partner } from '../../../global/constants';
import { AutomateTask, PartnerList, PartnerSiftrockFieldMap, PartnerStaticFieldMap, PartnerField } from '../../../global/models';
import { PartnerMapOptions } from '../../../global/partner-map/partner-map.component';
import { GlobalMessageService } from '../../../services/global-message.service';
import { PartnerService } from '../../../services/partner.service';
import { SessionService } from '../../../services/session2.service';

@Component({
  selector: 'app-track-task',
  templateUrl: './create-task.component.html'
})
export class CreateTaskComponent implements OnInit {
  @Input() task: AutomateTask;
  @Output() onChange = new Subject<AutomateTask>();
  @Output() onNavChange = new Subject<boolean>();

  session: any;

  // Partner map control
  partnerMapOptions: PartnerMapOptions = {
    listSelector: true,
    staticFieldSelector: true,
    siftrockFieldSelector: true,
    senderFieldSelector: false,
    skillType: 'create'
  };

  selectedPartner: Partner;
  selectedList: PartnerList;
  staticFieldMap: Array<PartnerStaticFieldMap> = [];
  siftrockFieldMap: Array<PartnerSiftrockFieldMap> = [];
  senderFieldMap: Array<PartnerField> = [];

  constructor(
    private cacheService: CacheService,
    private sessionService: SessionService,
    private constants: Constants,
    private globalMessageService: GlobalMessageService,
    private partnerService: PartnerService
  ) { }

  ngOnInit(): void {
    // skill componets assume they are loaded in dynamically via the skill-detail component.
    this.session = this.cacheService.get('session');
    this.initView();
  }

  initView() {
    // not doing ...senderFieldSelector=...settings.sender_field_mapping so we don't copy <null> over
    if (this.task.settings.sender_field_mapping) {
      this.partnerMapOptions.senderFieldSelector = true;
    }
    this.setupTask();
  }
  private setupTask() {
    if (this.task.settings.partner.length > 0) {
      this.selectedPartner = this.constants.partners.find(p => { return p.name == this.task.settings.partner; });
    }

    if (this.task.settings.list && this.task.settings.list.id) {
      this.selectedList = {
        id: this.task.settings.list.id,
        name: this.task.settings.list.name
      };
    }

    if (this.task.settings.static_fields.length > 0) {
      this.task.settings.static_fields.forEach(f => {
        this.staticFieldMap.push({
          partnerField: {
            id: f.id,
            name: f.name,
            display: f.display,
            type: f.type
          },
          value: f.value
        });
      });
    }

    if (this.task.settings.siftrock_fields.length > 0) {
      this.task.settings.siftrock_fields.forEach(f => {
        let srField = this.constants.siftrockFields.find(sf => { return sf.fieldName == f.value; });
        this.siftrockFieldMap.push({
          partnerField: {
            id: f.id,
            name: f.name,
            display: f.display,
            type: f.type
          },
          siftrockField: srField
        });
      });
    }

    if (this.task.settings.sender_fields) {
      this.senderFieldMap = this.task.settings.sender_fields
    }

    // some state management happens here
    this.checkValidTask();
  }

  /**
  * Event bubbled up from partner-picker through partner-map
  * The value will be null if the partner was cleared
  * @param partner
  */
  changePartner(partner: Partner) {
    this.selectedPartner = partner;
    if (partner) {
      this.task.settings.partner = partner.name;
    }
    else {
      this.task.settings.partner = '';
    }
    this.stage();
  }

  changeList(list: PartnerList) {
    this.selectedList = list;
    if (list) {
      this.task.settings.list = list;
    }
    else {
      this.task.settings.list = {};
    }
    this.stage();
  }

  changeStaticField(fields: Array<PartnerStaticFieldMap>) {
    this.task.settings.static_fields = [];
    if (fields.length > 0) {
      fields.forEach(f => {
        this.task.settings.static_fields.push({
          id: f.partnerField.id,
          display: f.partnerField.display,
          name: f.partnerField.name,
          type: f.partnerField.type,
          value: f.value
        });
      });
    }
    this.stage();
  }

  changeSiftrockField(fields: Array<PartnerSiftrockFieldMap>) {
    this.task.settings.siftrock_fields = [];
    if (fields.length > 0) {
      fields.forEach(f => {
        this.task.settings.siftrock_fields.push({
          id: f.partnerField.id,
          display: f.partnerField.display,
          name: f.partnerField.name,
          type: f.partnerField.type,
          value: f.siftrockField.fieldName
        });
      });
    }
    this.stage();
  }


  changeSenderField(fields: Array<PartnerField>) {
    this.task.settings.sender_fields = fields;
    // this.task.settings.sender_fields = [];
    // if (fields.length > 0) {
    //   this.task.settings.sender_fields.concat(fields);
    // }
    this.stage();
  }

  private checkValidTask() {
    let valid: boolean = true;
    let invalidReason: string = null;
    if (this.task) {
      if (this.task.settings.partner.length == 0) {
        valid = false;
        invalidReason = `A partner integration must be selected`;
      }
      else {
        // for now, no further validation necessary on create tasks
      }
    }

    this.task.valid = valid;
    this.task.invalid_reason = invalidReason;
  }

  /**
   * Stage changes to be saved
   */
  private stage() {
    this.checkValidTask();
    this.task.updated_at = new Date();
    this.onChange.next(this.task);
  }

}



// WEBPACK FOOTER //
// ./client/app/automate/tasks/create-task/create-task.component.ts